import * as React from 'react';
import Svg, {
	Path,
	Defs,
	LinearGradient,
	Stop,
} from 'react-native-svg';

const KfinLogo = (props: any) => {
	return (
		<Svg
			width={87}
			height={20}
			viewBox='0 0 87 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<Path
				d='M29.04 15.285h-1.996l-4.101-5.105v5.105h-1.518V5.197h1.518v4.958l3.893-4.958h1.848l-3.966 4.885 4.321 5.203zM29.884 15.285V5.197h6.133v1.408h-4.615v3.28h4.052v1.397h-4.052v4.003h-1.518zM37.363 15.285V5.197h1.518v10.088h-1.518zM40.815 15.284V4.988l7.003 7.089-.025-1.488c-.008-.477-.012-.99-.012-1.536V5.196h1.481v10.345l-6.99-7.112.025 1.511c.008.494.012.998.012 1.512v3.832h-1.494zM53.315 15.285v-8.68h-2.914V5.197h7.37v1.408h-2.925v8.68h-1.531zM58.91 15.285V5.197h6.145v1.396h-4.603v2.864h3.831v1.371h-3.831v3.061h4.787v1.396h-6.33zM71.225 15.48a5.515 5.515 0 01-3.831-1.51 5.164 5.164 0 01-1.157-1.66 5.057 5.057 0 01-.422-2.069c0-.742.14-1.432.422-2.068a5.169 5.169 0 011.157-1.66 5.364 5.364 0 011.72-1.101 5.62 5.62 0 012.123-.398c.719 0 1.355.098 1.91.293.555.196 1.008.413 1.36.65v1.738a4.2 4.2 0 00-.674-.52 5.037 5.037 0 00-1.695-.674 4.632 4.632 0 00-.913-.092 3.95 3.95 0 00-1.536.294c-.47.195-.873.467-1.212.814a3.792 3.792 0 00-.796 1.218 3.912 3.912 0 00-.287 1.506c0 .538.096 1.04.287 1.505.192.466.457.872.796 1.218.339.347.742.619 1.212.814.47.196.981.294 1.536.294.62 0 1.223-.118 1.806-.355a4.716 4.716 0 001.475-.918v1.739a6.676 6.676 0 01-1.377.648c-.55.197-1.186.295-1.904.295zM76.195 15.285V5.197h1.518v4.248h4.959V5.197h1.517v10.088h-1.517V10.84h-4.959v4.444h-1.518z'
				fill='#2057A6'
			/>
			<Path
				d='M17.284 17.22l2.85-.23.17.189a.123.123 0 01-.099.205l-2.92-.165z'
				fill='url(#paint0_linear_6017_14983)'
			/>
			<Path
				d='M9.066 2.023l1.963 1.95-2.686 9.512-2.638.739 3.361-12.2z'
				fill='url(#paint1_linear_6017_14983)'
			/>
			<Path
				d='M1.955 17.883l.61-2.778 9.798-2.75 2.126 2.102-12.534 3.426z'
				fill='url(#paint2_linear_6017_14983)'
			/>
			<Path
				d='M10.26 6.734l9.874 10.257-2.85.23-7.818-7.727.793-2.76z'
				fill='url(#paint3_linear_6017_14983)'
			/>
			<Path
				opacity={0.25}
				d='M2.564 15.104l9.799-2.748 2.126 2.101-11.925.647z'
				fill='url(#paint4_linear_6017_14983)'
			/>
			<Path
				opacity={0.25}
				d='M9.066 2.023l-.723 11.462-2.638.739 3.361-12.2z'
				fill='url(#paint5_linear_6017_14983)'
			/>
			<Path
				opacity={0.25}
				d='M10.26 6.734l7.024 10.486-7.818-7.726.793-2.76z'
				fill='url(#paint6_linear_6017_14983)'
			/>
			<Path
				d='M11.028 3.973l-1.68-2.269a.123.123 0 00-.22.046l-.063.273 1.963 1.95z'
				fill='url(#paint7_linear_6017_14983)'
			/>
			<Path
				d='M2.565 15.105l-.61 2.779-.248.082a.123.123 0 01-.154-.16l1.012-2.7z'
				fill='url(#paint8_linear_6017_14983)'
			/>
			<Defs>
				<LinearGradient
					id='paint0_linear_6017_14983'
					x1={17.2843}
					y1={17.1872}
					x2={20.3359}
					y2={17.1872}
					gradientUnits='userSpaceOnUse'
				>
					<Stop stopColor='#0FD4D8' />
					<Stop offset={0.2878} stopColor='#09B0B9' />
					<Stop offset={0.566} stopColor='#0495A1' />
					<Stop offset={0.8119} stopColor='#018593' />
					<Stop offset={1} stopColor='#007F8E' />
				</LinearGradient>
				<LinearGradient
					id='paint1_linear_6017_14983'
					x1={10.0966}
					y1={3.26929}
					x2={6.86881}
					y2={13.67}
					gradientUnits='userSpaceOnUse'
				>
					<Stop
						stopColor='#139FCE'
						stopOpacity={0.9}
					/>
					<Stop
						offset={0.3219}
						stopColor='#139CCB'
						stopOpacity={0.9322}
					/>
					<Stop
						offset={0.5804}
						stopColor='#1293C1'
						stopOpacity={0.958}
					/>
					<Stop
						offset={0.8161}
						stopColor='#1083B0'
						stopOpacity={0.9816}
					/>
					<Stop offset={1} stopColor='#0E719D' />
				</LinearGradient>
				<LinearGradient
					id='paint2_linear_6017_14983'
					x1={1.63081}
					y1={16.7461}
					x2={13.8734}
					y2={13.2576}
					gradientUnits='userSpaceOnUse'
				>
					<Stop stopColor='#337FC9' />
					<Stop offset={0.3501} stopColor='#317CC6' />
					<Stop offset={0.6313} stopColor='#2D72BD' />
					<Stop offset={0.8877} stopColor='#2561AF' />
					<Stop offset={1} stopColor='#2057A6' />
				</LinearGradient>
				<LinearGradient
					id='paint3_linear_6017_14983'
					x1={19.128}
					y1={17.3794}
					x2={10.2727}
					y2={8.52421}
					gradientUnits='userSpaceOnUse'
				>
					<Stop stopColor='#0FD4D8' />
					<Stop offset={0.2561} stopColor='#0ED1D5' />
					<Stop offset={0.4617} stopColor='#0DC7CC' />
					<Stop offset={0.6499} stopColor='#0AB6BE' />
					<Stop offset={0.8265} stopColor='#069EA9' />
					<Stop offset={0.9955} stopColor='#00808F' />
					<Stop offset={1} stopColor='#007F8E' />
				</LinearGradient>
				<LinearGradient
					id='paint4_linear_6017_14983'
					x1={2.14504}
					y1={16.5417}
					x2={13.4487}
					y2={13.4001}
					gradientUnits='userSpaceOnUse'
				>
					<Stop stopColor='#337FC9' />
					<Stop offset={0.3003} stopColor='#3079C4' />
					<Stop offset={0.6923} stopColor='#2869B6' />
					<Stop offset={1} stopColor='#2057A6' />
				</LinearGradient>
				<LinearGradient
					id='paint5_linear_6017_14983'
					x1={9.90518}
					y1={2.63597}
					x2={7.0104}
					y2={13.9077}
					gradientUnits='userSpaceOnUse'
				>
					<Stop
						stopColor='#139FCE'
						stopOpacity={0.9}
					/>
					<Stop
						offset={0.2648}
						stopColor='#129AC8'
						stopOpacity={0.9265}
					/>
					<Stop
						offset={0.6111}
						stopColor='#118AB8'
						stopOpacity={0.9611}
					/>
					<Stop offset={1} stopColor='#0E719D' />
				</LinearGradient>
				<LinearGradient
					id='paint6_linear_6017_14983'
					x1={19.1197}
					y1={17.0726}
					x2={10.0029}
					y2={8.38701}
					gradientUnits='userSpaceOnUse'
				>
					<Stop stopColor='#0FD4D8' />
					<Stop offset={0.1881} stopColor='#0ECED3' />
					<Stop offset={0.434} stopColor='#0BBEC5' />
					<Stop offset={0.7122} stopColor='#06A3AD' />
					<Stop offset={1} stopColor='#007F8E' />
				</LinearGradient>
				<LinearGradient
					id='paint7_linear_6017_14983'
					x1={9.19712}
					y1={1.85258}
					x2={11.0448}
					y2={3.96273}
					gradientUnits='userSpaceOnUse'
				>
					<Stop stopColor='#0E719D' />
					<Stop
						offset={0.3889}
						stopColor='#118AB8'
						stopOpacity={0.9611}
					/>
					<Stop
						offset={0.7352}
						stopColor='#129AC8'
						stopOpacity={0.9265}
					/>
					<Stop
						offset={1}
						stopColor='#139FCE'
						stopOpacity={0.9}
					/>
				</LinearGradient>
				<LinearGradient
					id='paint8_linear_6017_14983'
					x1={1.54479}
					y1={16.5394}
					x2={2.56473}
					y2={16.5394}
					gradientUnits='userSpaceOnUse'
				>
					<Stop stopColor='#337FC9' />
					<Stop offset={0.3077} stopColor='#2B6DB9' />
					<Stop offset={0.6997} stopColor='#235DAB' />
					<Stop offset={1} stopColor='#2057A6' />
				</LinearGradient>
			</Defs>
		</Svg>
	);
}

export default KfinLogo;
